import { Coupon } from "../coupon/Coupon";

export class RestaurantOffers {
    offerId:string;
    img:string|null;
    offerTitle:string|null;
    offerDescription:string|null;
    associatedCoupon:Coupon|null;

    /**
     * Constructor
     * @param offerId ID of the offer. Needs to be on the format "offer_[AFFIX]_[RESTAURANT REGION].[RESTAURANT ID]_[UNIQUE IDENTIFIER]", where the affix can be "rewardpoint" for reward
     *  point offers, or "special" for special offers. We will probably have more offer types in the future. Check the "applyRestaurantOffer" method on the 
     * "handler.ts" file on the "AvantoEats-FeesAndDiscounts" project for more info
     * @param img image associated with the offer. Will be displayed for the customer.
     * @param offerTitle ... duh ...
     * @param offerDescription ....
     * @param associatedCoupon Coupon object vinculated to this order. The coupon object will determine the discount you will receive, or whatever.
     */
    constructor(offerId:string, img:string|null, offerTitle:string|null, offerDescription:string|null, associatedCoupon:Coupon|null){
        this.offerId = offerId;
        this.img = img;
        this.offerTitle = offerTitle;
        this.offerDescription = offerDescription;
        this.associatedCoupon = associatedCoupon;
    }

    static newFromAws(awsSpecialOfferItem: any): RestaurantOffers {
        let coupon = null;
        if(awsSpecialOfferItem.associatedCoupon != null){
            coupon = Coupon.newFromAws(awsSpecialOfferItem.associatedCoupon);
        }
        return new RestaurantOffers(
            awsSpecialOfferItem.offerId,
            awsSpecialOfferItem.img,
            awsSpecialOfferItem.offerTitle,
            awsSpecialOfferItem.offerDescription,
            coupon
        )
    }
}